import React, { useEffect, useState } from 'react';
import { Table, Typography, VertButton, VertLoading, notification } from '@vertem-core/vertice-ds';
import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';
import { Col, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { postSolicitationCreateThunk } from 'redux/Reducers/Concierge/solicitationCreateSlicer';
import { putSolicitationEditThunk } from 'redux/Reducers/Concierge/solicitationEditSlicer';
import { resetDataSolicitationCreate } from 'redux/Reducers/Concierge/solicitationCreateSlicer';
import { resetDataSolicitationEdit } from 'redux/Reducers/Concierge/solicitationEditSlicer';
import ConfirmationRequestModal from '../Modals/ConfirmationRequestModal';
import { useNavigate } from 'react-router';
import { resetDataUploadFile } from 'redux/Reducers/Concierge/uploadFileSlicer';
import { getAddressThunk } from 'redux/Reducers/Concierge/addressSlicer';
import { BaseSteps, RegisterSteps } from 'pages/NewConciergeSolicitationPage/enum/new-solicitation-enum';
import { convertNumberToStringCurrency } from 'Utils/convertPoints';
import { shouldConvertToPoints } from 'Constants/Concierge';
import { formatCEP, formatDocument } from 'Utils/format';
import { pointsMask } from 'Utils/commons/points';
import { DownloadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const FinishSolicitation = ({ ...props }) => {
    const {
        solicitation,
        flowSteps,
        handlePreviousStep
    } = props;

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isOpenConfirmationRequestModal, setIsOpenConfirmationRequestModal] = useState(false);
    const [numberRequester, setNumberRequester] = useState(0);
    const [loadingFinish, setLoadingFinish] = useState(false);
    const [redemptionAddresses, setRedemptionAddresses] = useState({});

    const {
        user
    } = useSelector(
        (state) => state.oidc
    );

    const {
        dataSolicitationEdit,
        loadingSolicitationEdit,
        errorSolicitationEdit
    } = useSelector(
        (state) => state.SolicitationEdit
    );

    const {
        loadingSolicitationCreate,
        dataSolicitationCreate,
        errorSolicitationCreate,
    } = useSelector(
        (state) => state.SolicitationCreate
    );

    const {
        pointsName,
        decimalPlaces,
    } = useSelector(state =>
        state.Catalog?.currencyConfiguration
    )

    const finishProductSolicitation = async () => {
        const redemptionProducts = solicitation.productList.map(product => {
            return {
                name: product.title,
                sku: product.sku || null,
                subCategoryId: product.subCategory,
                description: product.description || null,
                quantity: Number(product.quantity),
                unitPrice: Number(product.unitValue),
            }
        });

        const addresses = [
            { ...redemptionAddresses.deliveryAddress, type: 1 },
            { ...redemptionAddresses.billingAddress, type: 2 }
        ]

        const redemptionSolicitation = {
            redemptionWorkflowId: solicitation.requestTypeId,
            participantId: Number(solicitation.participantId) || Number(user.profile["custom:participant_id"]),
            type: 1,
            supplierId: solicitation.supplierId,
            products: redemptionProducts,
            addresses: addresses,
            quoteFileName: solicitation.quoteFileName,
            quoteFileUrl: solicitation.quoteFileUrl,
        };

        const isSolicitationEdition = solicitation.redemptionId ?? false;

        if (isSolicitationEdition) {
            redemptionSolicitation.redemptionId = solicitation.redemptionId;
            dispatch(putSolicitationEditThunk(redemptionSolicitation));
        } else {
            dispatch(postSolicitationCreateThunk({ redemptionSolicitation }));
        }
    }

    const finishBillPaymentSolicitation = () => {
        const { barCode, date, pointsValue, subCategory, subCategoryLabel, isPriceEditable } = solicitation.productList[0];

        const redemptionBillPayment = {
            name: subCategoryLabel,
            serviceId: subCategory,
            barCode,
            pointsValue,
            isPriceEditable,
            dueDate: date,
        }

        const addresses = [
            { ...redemptionAddresses.billingAddress, type: 2 }
        ]

        const redemptionSolicitation = {
            redemptionWorkflowId: solicitation.requestTypeId,
            participantId: Number(solicitation.participantId) || Number(user.profile["custom:participant_id"]),
            redemptionBillPayment,
            addresses: addresses,
        }

        dispatch(postSolicitationCreateThunk({ isBillPayment: true, redemptionSolicitation }));
    }

    useEffect(() => {
        if (dataSolicitationCreate != null) {
            setLoadingFinish(false);
            setNumberRequester(dataSolicitationCreate);
            setIsOpenConfirmationRequestModal(true);

            dispatch(resetDataSolicitationCreate());
            dispatch(resetDataUploadFile());
        }
    }, [dataSolicitationCreate]);

    useEffect(() => {
        if (dataSolicitationEdit != null) {
            notification.success({
                message: "Edição concluída com sucesso."
            });

            navigate("/list-solicitations");

            dispatch(resetDataSolicitationEdit());
        }
    }, [dataSolicitationEdit]);

    useEffect(() => {
        if (!errorSolicitationCreate) return;

        let errorMsg = 'Houve um erro ao criar solicitação, tente novamente.';

        if (errorSolicitationCreate.data?.message)
            errorMsg = errorSolicitationCreate.data.message;

        notification.error({
            message: errorMsg,
        });

        dispatch(resetDataSolicitationCreate());
        setLoadingFinish(false);

    }, [errorSolicitationCreate]);

    useEffect(() => {
        if (!errorSolicitationEdit) return;

        let errorMsg = 'Houve um erro ao editar solicitação, tente novamente.';

        if (errorSolicitationCreate.data?.message)
            errorMsg = errorSolicitationCreate.data.message;

        notification.error({
            message: errorMsg,
        });

        dispatch(resetDataSolicitationEdit());
        setLoadingFinish(false);

    }, [errorSolicitationEdit]);

    const fetchAddresses = async () => {
        setLoadingFinish(true);

        let deliveryAddress;
        let billingAddress;

        if (flowSteps?.some(item => item.step == RegisterSteps.SelectAddress)) {
            deliveryAddress = solicitation.deliveryAddress;
            billingAddress = solicitation.billingAddress;
        }
        else {
            const addresses = await dispatch(getAddressThunk(solicitation.participantId)).unwrap();

            if (!addresses?.length) {
                notification.error({
                    message: 'Nenhum endereço vinculado ao participante.'
                });
                setLoadingFinish(false);
                return;
            }

            deliveryAddress = addresses[0];
            billingAddress = addresses[0];
        }

        const redemptionAddresses = { deliveryAddress, billingAddress };

        const propertiesToRemove = ["key", "value", "children", "label"];

        propertiesToRemove.forEach(prop => {
            delete redemptionAddresses.deliveryAddress[prop];
            delete redemptionAddresses.billingAddress[prop];
        });

        setRedemptionAddresses(redemptionAddresses);

        setLoadingFinish(false);
    };

    const hasAddress = !flowSteps?.length || flowSteps.some(item => item.step == RegisterSteps.SelectAddress);
    const hasSupplier = solicitation.supplierId && (!flowSteps?.length || flowSteps.some(item => item.step == BaseSteps.SelectSupplier));

    useEffect(() => {
        fetchAddresses();
    }, []);

    const wrapperPoints = (points) => {
        return `${pointsMask(points, decimalPlaces, pointsName).value} ${pointsName}`;
    }

    const columns = [
        {
            title: 'Categoria',
            dataIndex: 'categoryLabel',
            className: 'table-col-vertical-align',
            align: 'center'
        },
        {
            title: 'Subcategoria',
            dataIndex: 'subCategoryLabel',
            className: 'table-col-vertical-align',
            align: 'center'
        },
        {
            title: 'Produto/Serviço',
            dataIndex: 'title',
            className: 'table-col-vertical-align',
            align: 'center'
        },
        {
            title: 'Valor Unitário',
            dataIndex: 'pointsValue',
            className: 'table-col-vertical-align',
            align: 'center',
            render: (_, { unitValue, pointsValue }) => (
                <Row>
                    {
                        !unitValue && !(shouldConvertToPoints || pointsValue) && (
                            <Col span={24}>
                                <Typography.Text className='span-cell-content'>
                                    -
                                </Typography.Text>
                            </Col>
                        )
                    }

                    {
                        unitValue && (
                            <Col span={24}>
                                <Typography.Text className='span-cell-content'>
                                    {convertNumberToStringCurrency(unitValue)}
                                </Typography.Text>
                            </Col>
                        )
                    }

                    {
                        (shouldConvertToPoints && pointsValue) && (
                            <Col span={24}>
                                <Typography.Text className='span-cell-content'>
                                    {wrapperPoints(pointsValue)}
                                </Typography.Text>
                            </Col>
                        )
                    }
                </Row >
            ),
        },
        {
            title: 'Qtd.',
            dataIndex: 'quantity',
            align: 'center',
            className: 'table-col-vertical-align'
        },
        {
            title: 'Total',
            align: 'center',
            className: 'table-col-vertical-align',
            render: (_, { unitValue, quantity, pointsTotalValue = null }) => (
                <Row>
                    {
                        !unitValue && !(shouldConvertToPoints || pointsTotalValue) && (
                            <Col span={24}>
                                <Typography.Text className='span-cell-content'>
                                    -
                                </Typography.Text>
                            </Col>
                        )
                    }

                    {
                        unitValue && (
                            <Col span={24}>
                                <Typography.Text className='span-cell-content'>
                                    {convertNumberToStringCurrency(parseFloat(unitValue.replace(',', '.')) * quantity)}
                                </Typography.Text>
                            </Col>
                        )
                    }

                    {
                        (shouldConvertToPoints && pointsTotalValue) && (
                            <Col span={24}>
                                <Typography.Text className='span-cell-content'>
                                    {wrapperPoints(pointsTotalValue)}
                                </Typography.Text>
                            </Col>
                        )
                    }
                </Row>
            ),
        }
    ];

    const columnsBillPayment = [
        {
            title: 'Tipo de conta',
            dataIndex: 'subCategoryLabel',
            className: 'table-col-vertical-align',
            width: '30%',
            align: 'center'
        },
        {
            title: 'Valor em pontos',
            dataIndex: 'pointsValue',
            className: 'table-col-vertical-align',
            align: 'center',
            render: (_, { pointsValue }) => (
                <Row>
                    <Col span={24}>
                        <Typography.Text className='span-cell-content'>
                            {pointsValue ? wrapperPoints(pointsValue) : '-'}
                        </Typography.Text>
                    </Col>
                </Row >
            ),
        },
        {
            title: 'Valor em dinheiro',
            dataIndex: 'unitValue',
            className: 'table-col-vertical-align',
            align: 'center',
            render: (_, { unitValue }) => (
                <Row>
                    <Col span={24}>
                        <Typography.Text className='span-cell-content'>
                            {unitValue ? convertNumberToStringCurrency(unitValue) : '-'}
                        </Typography.Text>
                    </Col>
                </Row >
            ),
        },
        {
            title: 'Data',
            dataIndex: 'date',
            align: 'center',
            className: 'table-col-vertical-align',
            render: (_, { date }) => (
                <Row>
                    <Col span={24}>
                        {dayjs(date).format('DD/MM/YYYY')}
                    </Col>
                </Row>
            )
        }
    ];

    return (
        <>
            {loadingFinish
                ? <VertLoading className='loading-space' />
                : <div>
                    <div className='container-concierge-information-main'>
                        <Row justify={'center'} className='margin-bottom-regular'>
                            <Typography.Text className='text-title-finish'>
                                Revise os dados da solicitação
                            </Typography.Text>
                        </Row>

                        {solicitation.clientName &&
                            <Row className='margin-top-regular'>
                                <Col>
                                    <Typography.Text className='text-subtitle'>
                                        Cliente:
                                    </Typography.Text>
                                    <Typography.Text className='margin-left-extra-small'>
                                        {solicitation.clientName}
                                    </Typography.Text>
                                </Col>
                            </Row>
                        }

                        {hasAddress &&
                            <Row className='margin-top-small'>

                                {!!redemptionAddresses.billingAddress &&
                                    <Col sm={24} md={12}>
                                        <div>
                                            <Typography.Text className='text-subtitle'>
                                                Endereço de faturamento
                                            </Typography.Text>

                                            <div className='margin-top-extra-small'>
                                                <Typography.Text className='margin-right-extra-small' strong>
                                                    Nome:
                                                </Typography.Text>
                                                <Typography.Text >
                                                    {redemptionAddresses.billingAddress.name}
                                                </Typography.Text>
                                            </div>
                                            <div>
                                                <Typography.Text className='margin-right-extra-small' strong>
                                                    Documento:
                                                </Typography.Text>
                                                <Typography.Text >
                                                    {formatDocument(redemptionAddresses.billingAddress.document)}
                                                </Typography.Text>
                                            </div>
                                            <div>
                                                <Typography.Text className='margin-right-extra-small' strong>
                                                    CEP:
                                                </Typography.Text>
                                                <Typography.Text>
                                                    {formatCEP(redemptionAddresses.billingAddress.zipCode)}
                                                </Typography.Text>
                                            </div>
                                            <div>
                                                <Typography.Text className='margin-right-extra-small' strong>
                                                    Endereço:
                                                </Typography.Text>
                                                <Typography.Text>
                                                    {`${redemptionAddresses.billingAddress.street}, ${redemptionAddresses.billingAddress.number} ${redemptionAddresses.billingAddress?.complement ?? ''}`}
                                                </Typography.Text>
                                            </div>
                                            <div>
                                                <Typography.Text className='margin-right-extra-small' strong>
                                                    Bairro:
                                                </Typography.Text>
                                                <Typography.Text>
                                                    {redemptionAddresses.billingAddress.district}
                                                </Typography.Text>
                                            </div>
                                            <div>
                                                <Typography.Text className='margin-right-extra-small' strong>
                                                    Cidade:
                                                </Typography.Text>
                                                <Typography.Text>
                                                    {`${redemptionAddresses.billingAddress.city} - ${redemptionAddresses.billingAddress.state}`}
                                                </Typography.Text>
                                            </div>
                                        </div>
                                    </Col>
                                }

                                {!solicitation.isBillPayment && !!redemptionAddresses.deliveryAddress &&
                                    <Col sm={24} md={12}>
                                        <div className='container-address-shipping'>

                                            <Typography.Text className='text-subtitle'>
                                                Endereço de entrega
                                            </Typography.Text>

                                            <div className='margin-top-extra-small'>
                                                <Typography.Text className='margin-right-extra-small' strong>
                                                    Nome:
                                                </Typography.Text>
                                                <Typography.Text >
                                                    {redemptionAddresses.deliveryAddress.name}
                                                </Typography.Text>
                                            </div>
                                            <div>
                                                <Typography.Text className='margin-right-extra-small' strong>
                                                    Documento:
                                                </Typography.Text>
                                                <Typography.Text >
                                                    {formatDocument(redemptionAddresses.deliveryAddress.document)}
                                                </Typography.Text>
                                            </div>
                                            <div>
                                                <Typography.Text className='margin-right-extra-small' strong>
                                                    CEP:
                                                </Typography.Text>
                                                <Typography.Text>
                                                    {formatCEP(redemptionAddresses.deliveryAddress.zipCode)}
                                                </Typography.Text>
                                            </div>
                                            <div>
                                                <Typography.Text className='margin-right-extra-small' strong>
                                                    Endereço:
                                                </Typography.Text>
                                                <Typography.Text>
                                                    {`${redemptionAddresses.deliveryAddress.street}, ${redemptionAddresses.deliveryAddress.number} ${redemptionAddresses.deliveryAddress?.complement ?? ''}`}
                                                </Typography.Text>
                                            </div>
                                            <div>
                                                <Typography.Text className='margin-right-extra-small' strong>
                                                    Bairro:
                                                </Typography.Text>
                                                <Typography.Text>
                                                    {redemptionAddresses.deliveryAddress.district}
                                                </Typography.Text>
                                            </div>
                                            <div>
                                                <Typography.Text className='margin-right-extra-small' strong>
                                                    Cidade:
                                                </Typography.Text>
                                                <Typography.Text>
                                                    {`${redemptionAddresses.deliveryAddress.city} - ${redemptionAddresses.deliveryAddress.state}`}
                                                </Typography.Text>
                                            </div>
                                        </div>
                                    </Col>
                                }
                            </Row>
                        }

                        {!solicitation.isBillPayment && hasSupplier &&
                            <Row className='margin-top-regular'>
                                <Col>
                                    <Typography.Text className='text-subtitle'>
                                        Fornecedor de preferência:
                                    </Typography.Text>
                                    <Typography.Text className='margin-left-extra-small'>
                                        {solicitation.supplierName}
                                    </Typography.Text>
                                    {solicitation.quoteFileName &&
                                        <VertButton
                                            className='quotation-file'
                                            type="default"
                                            shape="round"
                                            icon={<DownloadOutlined />}
                                            size="small"
                                            download
                                            href={solicitation.quoteFileUrl}>
                                            {solicitation.quoteFileName}
                                        </VertButton>
                                    }
                                </Col>
                            </Row>
                        }
                    </div>

                    <Row className='margin-top-regular'>
                        <Col className='width-100'>
                            <Typography.Text className='text-subtitle'>
                                Produtos/Serviços
                            </Typography.Text>
                        </Col>

                        <Col className='width-100'>
                            <Table
                                bordered
                                className='margin-top-small quotation-table'
                                pagination={false}
                                dataSource={solicitation.productList}
                                columns={solicitation.isBillPayment ? columnsBillPayment : columns}
                                scroll={{ x: "800px" }}
                            />
                        </Col>
                    </Row>

                    <Row gutter={[8, 8]} justify={'end'} className='btn-group margin-top-regular'>
                        <Col className='collum-btn-concierge'>
                            <VertButton
                                className='button-continue button-concierge'
                                type='default'
                                size="default"
                                onClick={() => handlePreviousStep()}>
                                <Typography.Text className='span-button-return'>
                                    Voltar
                                </Typography.Text>

                            </VertButton>
                        </Col>
                        <Col className='collum-btn-concierge'>
                            <VertButton
                                htmlType="submit"
                                className='button-continue button-concierge'
                                type='highlight'
                                size="default"
                                loading={loadingSolicitationCreate || loadingSolicitationEdit}
                                onClick={() => {
                                    setLoadingFinish(true);
                                    solicitation.isBillPayment ? finishBillPaymentSolicitation() : finishProductSolicitation();
                                }}>
                                <Typography.Text className='span-button-continue'>
                                    {solicitation.redemptionId ? "Finalizar edição" : "Finalizar solicitação"}
                                </Typography.Text>
                            </VertButton>
                        </Col>
                    </Row>

                    <ConfirmationRequestModal
                        isBillPayment={solicitation.isBillPayment}
                        isOpen={isOpenConfirmationRequestModal}
                        numberRequester={numberRequester}
                        onClose={() => navigate("/list-solicitations")}
                    />
                </div >
            }
        </>
    )
}

FinishSolicitation.propTypes = {
    solicitation: PropTypes.object.isRequired,
    flowSteps: PropTypes.array.isRequired,
    handlePreviousStep: PropTypes.func.isRequired,
};

export default FinishSolicitation;
